/*global angular */
/*jslint node: true */

'use strict';

var link = angular.module('link', []);

link.service('linkSlot', ['$templateCache', function ($templateCache) {
    return {
        getTemplate: function () {
            return $templateCache.get('slots/link/link.html');
        },
        config: {
            title: 'Link',
            visible: function (context_type, context) {
                return context_type == 'slot' && context.type == 'link';
            },
            template: $templateCache.get('slots/link/link_config.html.html')
        }
    };
}]);
